import React from "react";
import { useRouteMatch } from "react-router-dom";

import { DefinedRoute, RouteParams, substituteRouteParameters } from "routes";
import { LinkButton } from "components/LinkButton";

// eslint-disable-next-line no-restricted-imports
import { PermissionEnforcer } from "../../../../common/authorization";

export const SubNav = React.memo(
  ({
    enforcer,
    routes,
  }: {
    routes: DefinedRoute[];
    enforcer: PermissionEnforcer;
  }) => {
    const { path: currentPath, params } = useRouteMatch<RouteParams>();
    const routesBelowCurrentPath = routes.filter(
      ({ path }) =>
        currentPath !== "/" &&
        path.startsWith(currentPath) &&
        path.substring(currentPath.length).split("/").length === 2
    );
    const subNav = substituteRouteParameters(routesBelowCurrentPath, params);
    const subNavWithPermissions = subNav.filter(({ requiredPermission }) =>
      enforcer.can(requiredPermission, { ...params })
    );
    return subNavWithPermissions.length === 0 ? null : (
      <div className="items-center leading-tight flex mt-2">
        {subNavWithPermissions.map(({ path, title }, index) => (
          <LinkButton key={index} to={path} className={index > 0 ? "ml-4" : ""}>
            {title}
          </LinkButton>
        ))}
      </div>
    );
  }
);
